import { TWeeklyForecast } from "../../../store/dashboard/types";

const forecast = [
  { day: "Mon", urgentCount: 2, standardCount: 4 },
  { day: "Tue", urgentCount: 4, standardCount: 6 },
  { day: "Wed", urgentCount: 2, standardCount: 2 },
  { day: "Thu", standardCount: 7 },
  { day: "Fri", urgentCount: 9 },
  { day: "Sat" },
  { day: "Sun" },
];

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const WeeklyForecast = ({
  weekly_forecast,
}: {
  weekly_forecast: TWeeklyForecast;
}) => {
  const getBarStyle = (
    count: number | undefined,
    color: string,
    isTop = false,
    isBottom = false
  ) => {
    const radiusClass = isTop
      ? "radius-top-8px"
      : isBottom
      ? "radius-bottom-8px"
      : "";

    return `d-flex flex-column justify-content-center ${color} ${radiusClass}`;
  };

  return (
    <div className="border border-grey-light radius-8px p-10px d-flex flex-column gap-10">
      <div className="d-flex flex-column gap-3 fs-16 text-black">
        <div className="fw-700">Weekly Forecast</div>
        <div className="fw-400">
          Total urgent and standard vacancies based on past averages
        </div>
      </div>

      <div className="d-flex align-items-end gap-3 fs-16 fw-700 text-black text-center">
        {days.map((day) => {
          const urgentCount = weekly_forecast[day]?.urgent ?? 0;
          const scheduledCount = weekly_forecast[day]?.scheduled ?? 0;

          return (
            <div className="d-flex flex-column w-100" key={day}>
              {urgentCount > 0 && (
                <div
                  className={getBarStyle(
                    urgentCount,
                    "bg-alert text-white",
                    true
                  )}
                  style={{
                    height:
                      urgentCount === 1 ? "15px" : `${urgentCount * 10}px`,
                  }}
                >
                  {urgentCount}
                </div>
              )}
              {scheduledCount > 0 && (
                <div
                  className={getBarStyle(scheduledCount, "bg-teal-light")}
                  style={{ height: `${scheduledCount * 10}px` }}
                >
                  {scheduledCount}
                </div>
              )}
              <div
                className={getBarStyle(1, "bg-teal", false, true)}
                style={{ height: "40px" }}
              >
                {day}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WeeklyForecast;
